module.exports = __webpack_public_path__ + "img/Jump Casting118.44263a23.jpg";